/**
 * 法人（クリニック）GTM スクリプト注入
 *
 * クリニック切替時は前のタグを削除してから新しいタグを注入する。
 * GTM未設定のクリニックに切り替えた場合は前のタグのみ削除。
 */

let currentHeadScript: HTMLScriptElement | null = null
let currentBodyNoscript: HTMLElement | null = null

/**
 * Inject GTM (Google Tag Manager) script tags into the document.
 * Removes previously injected clinic GTM tags before adding new ones.
 *
 * Security note: head/body values come from clinic admin settings via the API.
 * This is a trusted data source managed by authenticated clinic administrators.
 * The innerHTML assignment is intentional to execute GTM scripts.
 */
export function injectGtmTags(head: string, body: string): void {
  try {
    // Remove previously injected tags
    if (currentHeadScript) {
      currentHeadScript.remove()
      currentHeadScript = null
    }
    if (currentBodyNoscript) {
      currentBodyNoscript.remove()
      currentBodyNoscript = null
    }

    // Inject new tags
    if (head) {
      const script = document.createElement('script')
      script.innerHTML = head
        .replace(/<script[^>]*>/i, '')
        .replace(/<\/script>/i, '')
        .replace(/<!-- Google Tag Manager -->/i, '')
        .replace(/<!-- End Google Tag Manager -->/i, '')
      document.head.appendChild(script)
      currentHeadScript = script
    }

    if (body && document.body) {
      const noscript = document.createElement('noscript')
      noscript.innerHTML = body
        .replace(/<noscript[^>]*>/i, '')
        .replace(/<\/noscript>/i, '')
        .replace(/<!-- Google Tag Manager \(noscript\) -->/i, '')
        .replace(/<!-- End Google Tag Manager \(noscript\) -->/i, '')
      document.body.appendChild(noscript)
      currentBodyNoscript = noscript
    }
  } catch {
    // GTM injection error should not block app initialization
  }
}
